import {Link} from "react-router-dom";

export default function Footer() {
    return (
            <div className="site-footer">
                <div className='site-footer-container'>
                    <div className='site-footer-grid-container'>
                        <div className='cell'>
                            <h3>Shop Sex Toys</h3>
                            <div>
                                <Link className='site-footer-item' to='https://www.fleshlight.com?utm_source=fleshlightvip'>Fleshlight</Link>
                            </div>
                            <div>
                                <Link className='site-footer-item' to='https://www.fleshjack.com?utm_source=fleshlightvip'>Fleshjack</Link>
                            </div>
                        </div>
                        <div className='cell'>
                        <h3>Customer Care</h3>
                            <div>
                                <Link className='site-footer-item' to='https://www.fleshlight.com/pages/contact-us'>Contact Us</Link>
                            </div>
                            <div>
                                <Link className='site-footer-item' to='https://www.fleshlight.com/policies/refund-policy'>Refund Policy</Link>
                            </div>
                            <div>
                                <Link className='site-footer-item' to='https://www.fleshlight.com/policies/shipping-policy'>Shipping Policy</Link>
                            </div>
                        </div>
                        <div className='cell'>
                        <h3>Discover</h3>
                            <div>
                                <Link className='site-footer-item' to='https://www.instagram.com/notaflashlight?igsh=Ymwxcm4yYzdiOTR5'>Instagram</Link>
                            </div>
                            <div>
                                <Link className='site-footer-item' to='https://www.youtube.com/channel/UC5RyLV2QzLFVF5SUCXsUn_A'>Youtube</Link>
                            </div>
                            <div>
                                <Link className='site-footer-item' to='https://www.reddit.com/r/fleshlight/'>Reddit</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='site-footer-container'></div>
                <div className='site-footer-container'>
                    <div className='site-footer-policy'>
                        <Link className='site-footer-link' to='https://www.fleshlight.com/pages/contact-us'>Contact Us</Link>
                        <Link className='site-footer-link' to='https://www.fleshlight.com/policies/refund-policy'>Refund Policy</Link>
                        <Link className='site-footer-link' to='https://www.fleshlight.com/policies/shipping-policy'>Shipping Policy</Link>
                        <Link className='site-footer-link' to='https://www.fleshlight.com/policies/privacy-policy'>Privacy Policy</Link>
                        <Link className='site-footer-link' to='https://www.fleshlight.com/policies/terms-of-service'>Terms of Service</Link>
                    </div>
                </div>
            </div>
    )
}